import { FormHelperTextProps, FormHelperText } from '@material-ui/core';
import * as React from 'react';

export type DSFormHelperTextProps = FormHelperTextProps;
export const DSFormHelperText: React.FC<DSFormHelperTextProps> = props => <FormHelperText {...props} />;
DSFormHelperText.displayName = 'DSFormHelperText';
